import { forwardRef, PropsWithChildren } from 'react';

import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';

const feedbackBannerIcon = getDesignSystemIcon('icon-speachbubble-16.svg');

export const FeedbackBanner = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<{ label: string; visible: boolean; onClick: () => void; reverse: boolean }>
>(({ label, visible, onClick, reverse = 'false' }, ref) => {
  if (!visible) {
    return null;
  }

  return (
    <button
      data-testid="feedbackBanner"
      className={`focus-visible:outline outline-primary-black outline-2 outline-offset-2 group fixed bottom-0 z-50 flex w-full cursor-pointer items-center justify-center gap-2 border-t-8 border-primary-orange bg-secondary-light px-4 py-4 stihl-text-h5-mobile desktop:bottom-auto ${
        reverse ? 'desktop:right-2' : 'desktop:left-2'
      } desktop:top-[calc(100%)] desktop:w-auto desktop:translate-y-[-4.5rem] desktop:flex-col desktop:gap-4 desktop:border-0 desktop:bg-primary-orange desktop:py-6 desktop:text-primary-white desktop:transition-transform desktop:stihl-text-h3-desktop desktop:hover:-translate-y-full`}
      onClick={onClick}
      ref={ref}
    >
      <div>
        <svg className="h-6 w-6 lg:h-8 lg:w-8">
          <use xlinkHref={`${feedbackBannerIcon}#img`} className="text-primary-black" />
        </svg>
      </div>
      <div className="text-primary-black lg:[writingMode:vertical-lr]">{label}</div>
    </button>
  );
});
